import { useCallback } from 'react';
import { useEffectOnce } from 'react-use';
// eslint-disable-next-line no-restricted-imports
import { DIALOGS } from '../../../../routing/constants';
import { UseDialogStepsHook, Steps } from '../typings';
import {
    pushDialogState,
    replaceDialogState,
    goBack,
    extractDialogState,
} from '../utils/historyUtils';

export const useDialogSteps = (
    initialStep: Steps,
    onStepChange?: (step: Steps, additionalData?: Record<string, unknown>) => void,
): UseDialogStepsHook => {
    const handlePopState = useCallback(
        (event: PopStateEvent) => {
            const dialogState = extractDialogState(event);
            const step = (dialogState?.step as Steps) || initialStep;
            onStepChange?.(step, dialogState);
        },
        [initialStep, onStepChange],
    );

    useEffectOnce(() => {
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    });

    const goToStep = useCallback(
        (step: Steps, additionalData?: Record<string, unknown>) => {
            pushDialogState(DIALOGS.CREATE_COLLECTION, { step, ...additionalData });
            onStepChange?.(step, { step, ...additionalData });
        },
        [onStepChange],
    );

    const replaceStep = useCallback(
        (step: Steps, additionalData?: Record<string, unknown>) => {
            replaceDialogState(DIALOGS.CREATE_COLLECTION, { step, ...additionalData });
            onStepChange?.(step, { step, ...additionalData });
        },
        [onStepChange],
    );

    const navigateBack = useCallback(() => {
        goBack();
    }, []);

    return {
        goToStep,
        replaceStep,
        navigateBack,
    };
};
